import React, { Suspense } from 'react';
import {
    Box,
    VStack,
    HStack,
    Input,
    InputGroup,
    InputLeftElement,
    Icon,
    Text,
    IconButton,
    Center,
} from '@chakra-ui/react';
import { AiOutlineSearch, AiOutlineClose } from 'react-icons/ai';
import { Router } from '../../../../../../base';
import { CardSpinner } from '../../../../../../../domain';
import { ReportingShellViewBaseConfig } from '../../../base';
import { InsertOverlayViewProps } from './insertOverlayProps';
import { InsertOverviewContainerProps } from '../overview';
import { TemplateDetailRouteProps } from '../../template/detail';

export function createInsertOverlayView(
    config: ReportingShellViewBaseConfig & {
        Container: {
            Insert: React.FC<InsertOverviewContainerProps>;
        };
        Route: {
            Template: {
                Detail: React.FC<TemplateDetailRouteProps>;
            };
        };
    }
): React.FC<InsertOverlayViewProps> {
    const {
        UI: {
            Application: { createErrorBoundary },
        },
        Container: { Insert: InsertOverviewContainer },
        Route: {
            Template: { Detail: TemplateDetailRoute },
        },
        router: {
            insert: {
                Component: { Root, Route, Outlet },
            },
        },
    } = config;

    const ErrorBoundary = createErrorBoundary({
        errorClass: Error,
    });

    return (props) => {
        return (
            <Box
                w="25rem" // Fixed width similar to chat overlay default
                h="full"
                position="relative"
                bg="black"
                borderLeftWidth={2}
                borderColor="whiteAlpha.300"
                {...(props.overlay.isOpen ? {} : { w: 0, overflow: 'hidden' })}
            >
                <VStack w="full" h="full" spacing={0} bg="whiteAlpha.50">
                    {/* Content */}
                    <Box flex={1} w="full">
                        <Root>
                            <Route
                                element={
                                    <Suspense
                                        fallback={
                                            <Center h="full" w="full">
                                                <CardSpinner />
                                            </Center>
                                        }
                                    >
                                        <Outlet />
                                    </Suspense>
                                }
                            >
                                <Route
                                    index={true}
                                    element={
                                        <InsertOverviewContainer
                                            {...props.overview}
                                            overlay={props.overlay}
                                        />
                                    }
                                />
                                <Route
                                    path="template/:templateId"
                                    element={
                                        <TemplateDetailRoute overlay={props.overlay} />
                                    }
                                />
                            </Route>
                        </Root>
                    </Box>
                </VStack>
            </Box>
        );
    };
}
